import { render } from "./MyScheduledProgramDataTable.vue?vue&type=template&id=76470d1f"
import script from "./MyScheduledProgramDataTable.vue?vue&type=script&lang=js"
export * from "./MyScheduledProgramDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__